import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { StatusPill, PROJECT_STATUSES, fmtDate } from './TasksCommon';
import './Tasks.css';

export default function ProjectList() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: '', description: '', team: '', status: 'planned',
    start_date: '', end_date: '',
  });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [pRes, tRes] = await Promise.all([api.getProjects(), api.getTeams()]);
      setProjects(pRes.data.results || pRes.data);
      setTeams(tRes.data.results || tRes.data);
    } catch { /* ignore */ }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.title || !form.team) return;
    setSaving(true);
    try {
      const res = await api.createProject({
        title: form.title,
        description: form.description,
        team: form.team,
        status: form.status,
        start_date: form.start_date || null,
        end_date: form.end_date || null,
      });
      setShowForm(false);
      setForm({ title: '', description: '', team: '', status: 'planned', start_date: '', end_date: '' });
      navigate(`/tasks/projects/${res.data.id}`);
    } catch (e) {
      alert('Не удалось создать проект: ' + (e.response?.data?.detail || e.message));
    }
    setSaving(false);
  };

  return (
    <div className="tasks-page">
      <div style={{ marginBottom: 8 }}>
        <Link to="/tasks" style={{ color: '#6b7280', textDecoration: 'none', fontSize: 14 }}>← Дашборд задач</Link>
      </div>
      <h1>Проекты</h1>

      <div className="tasks-toolbar">
        <button className="tasks-btn primary" onClick={() => setShowForm(true)}>+ Новый проект</button>
      </div>

      {loading ? (
        <div className="tasks-empty">Загрузка…</div>
      ) : projects.length === 0 ? (
        <div className="tasks-empty">Проектов пока нет. Создайте первый.</div>
      ) : (
        <div className="tasks-grid">
          {projects.map((p) => (
            <div className="tasks-card" key={p.id} onClick={() => navigate(`/tasks/projects/${p.id}`)}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <h3>{p.title}</h3>
                <StatusPill value={p.status} list={PROJECT_STATUSES} />
              </div>
              <div className="meta">
                {p.team_name} · {p.tasks_done}/{p.tasks_total} задач
              </div>
              <div className="meta" style={{ marginTop: 4 }}>
                {p.start_date ? `с ${fmtDate(p.start_date)}` : ''}
                {p.end_date ? ` до ${fmtDate(p.end_date)}` : ''}
              </div>
              <div className="progress-bar"><div className="progress-fill" style={{ width: `${p.progress}%` }} /></div>
              <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>{p.progress}% готово</div>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div className="tasks-modal-overlay" onClick={() => setShowForm(false)}>
          <div className="tasks-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowForm(false)}>×</button>
            <h2>Новый проект</h2>
            <div className="tasks-form-row">
              <label>Название*</label>
              <input className="tasks-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
            </div>
            <div className="tasks-form-row">
              <label>Описание</label>
              <textarea className="tasks-textarea" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
            </div>
            <div className="tasks-form-row">
              <label>Команда*</label>
              <select className="tasks-select" value={form.team} onChange={(e) => setForm({ ...form, team: e.target.value })}>
                <option value="">— выбрать —</option>
                {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
            <div className="tasks-form-row">
              <label>Статус</label>
              <select className="tasks-select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                {PROJECT_STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
            <div className="tasks-form-row">
              <label>Дата старта</label>
              <input type="date" className="tasks-input" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} />
            </div>
            <div className="tasks-form-row">
              <label>Дата завершения</label>
              <input type="date" className="tasks-input" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} />
            </div>
            <div className="tasks-form-actions">
              <button className="tasks-btn" onClick={() => setShowForm(false)}>Отмена</button>
              <button className="tasks-btn primary" onClick={handleCreate} disabled={saving || !form.title || !form.team}>
                {saving ? 'Создание…' : 'Создать'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
